import { render, staticRenderFns } from "./FailedTests.vue?vue&type=template&id=6286b118&"
import script from "./FailedTests.vue?vue&type=script&lang=js&"
export * from "./FailedTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports